export const SET_RTPS_SEARCH_COMPLETE = 'setRTPSSearchResults';
export const SET_RTPS_SEARCH_BUSY = 'setRTPSSearchBusy';
export const SET_RTPS_EXPORT_BUSY = 'setRTPSExportBusy';
export const SAVE_RTPS_EXPORT_FIELDS = 'saveRTPSExportFields';
export const SET_RTPS_METRICS = 'setRTPSMetrics';



// WEBPACK FOOTER //
// ./src/store/rtps/rtps.mutations.js